import * as React from "react";
import { useHistory } from "react-router-dom";
import { signOut } from "@kahunmedical/user-management";
import { CLINIC_MANAGE_URL } from "./clinicSettings/clinicUrls";
import {
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  styled,
} from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { ClinicRoute } from "../../clinic/ClinicRoutes";
import { useClinicUser } from "./hooks/useClinicUser";

//region [[ Styles ]]

const ArrowButton = styled("button")(({ theme }) => ({
  padding: 0,
  background: "transparent",
  border: "none",
  cursor: "pointer",
  "& svg": {
    fill: "currentColor",
  },
  "&:hover": {
    color: theme.palette.primary.main,
  },
}));

const UserInfoView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  position: "relative",
  cursor: "pointer",
  fontSize: 14,
  color: theme.palette.primary.main,
  "&.absolute": {
    position: "absolute",
    right: "10px",
    top: "10px",
  },
}));

const UserMenu = styled(Menu)({
  fontSize: 14,
  marginTop: 22,
  "& li": {
    fontSize: 14,
  },
  "& ul": {
    padding: "4px 0",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicLoginWidgetProps {
  className?: string;
  style?: React.CSSProperties;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const UserInfo = ({ ...props }: ClinicLoginWidgetProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const history = useHistory();
  const { loading, clearUser, username } = useClinicUser("");

  const gotoLogin = () => {
    history.push(`${CLINIC_MANAGE_URL}/${ClinicRoute.Login}`);
  };
  const onLogout = () => {
    clearUser();
    signOut().then(() => gotoLogin());
  };

  if (loading) {
    return (
      <UserInfoView className={props.className} style={props.style}>
        <CircularProgress size={20} color={"secondary"} />
      </UserInfoView>
    );
  }

  if (!username) {
    return (
      <UserInfoView className={props.className} style={props.style}>
        <Button
          variant={"text"}
          onClick={() => {
            gotoLogin();
          }}
          style={{ marginLeft: "auto", textTransform: "none" }}
        >
          Login/Signup
        </Button>
      </UserInfoView>
    );
  }
  return (
    <>
      <UserInfoView
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
        className={"user-info " + props.className}
        style={props.style}
      >
        {username}
        <AccountCircle style={{ marginLeft: 2 }} />
        <ArrowButton>
          <ArrowDropDownIcon />
        </ArrowButton>
      </UserInfoView>
      <UserMenu
        className={"user-menu"}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => onLogout()}>Logout</MenuItem>
      </UserMenu>
    </>
  );
};
